import type { PlayerLobbyData } from "../../store";
import type { PlayerGameData } from "./types";

export function getOpenLobbyPlayerName(
  playerId: string,
  lobbyPlayers: Record<string, PlayerLobbyData> | undefined,
): string {
  return lobbyPlayers?.[playerId]?.name ?? playerId.slice(0, 8);
}

export function sortOpenLobbyPlayerEntries(
  gamePlayers: Record<string, PlayerGameData>,
  lobbyPlayers: Record<string, PlayerLobbyData> | undefined,
  locale: string,
): Array<[string, PlayerGameData]> {
  const collator = new Intl.Collator(locale, {
    sensitivity: "base",
    numeric: true,
  });

  return Object.entries(gamePlayers).sort(([firstId], [secondId]) => {
    const nameComparison = collator.compare(
      getOpenLobbyPlayerName(firstId, lobbyPlayers),
      getOpenLobbyPlayerName(secondId, lobbyPlayers),
    );

    return nameComparison || collator.compare(firstId, secondId);
  });
}
